<!DOCTYPE html>
<html lang="pt-br">

<head>
    <meta charset="UTF-8">
    <title>Sobre Nós</title>
</head>

<body>

    <div class="container-fluid">
        <app-menu></app-menu>
    </div>

            
    <section>
        <div class="circle"></div>
        <div class="content">
            <div class="imgBox">
                <img src="https://imgur.com/7zlGG21.jpg.png" width="550" height="550" class="imagem">
            </div>
            <div class="textBox mr-5">
                <h2>A primeira rede social dedicada exclusivamente a doação de itens.<br>Esse é o <span>Repassa</span>
                </h2>
                <br />
                <p>Inspirada na ODS 12 da Onu, "Consumo e produção responsáveis", a Repassa é uma rede social criada com
                    o propósito de dar novos significados a itens do lar, como móveis e eletrodomésticos. </p>
                <p>Você dá adeus àquele item que está parado na sua casa e ajuda pessoas que não podem comprá-lo. Com
                    isso, você reduz os impactos ambientais e ainda ajuda alguém que precisa.</p>
                <a class="btn mt-4" routerLink="/cadastrar">Cadastre-se</a>
            </div>

        </div>
    </section>

    <section>
        <div class="content">
            <div class="textBox ml-5">
                <h2>A nossa <span>missão</span></h2>
                <br />
                <p>Alcançar um consumo mais consciente exige esforço por parte da população, é claro, mas é também papel
                    das cidades e de seus respectivos governos fazer com que o ODS seja alcançado.</p>
                <p>A nossa missão é sermos reconhecidos como uma rede social que promove a reutilização de objetos como
                    forma de proporcionar bem-estar para os doadores e os favorecidos. Ou seja, para todos os usuários
                    da plataforma.</p>
            </div>
            <div class="imgBox">
                <img src="https://imgur.com/lp3m1zI.jpg.png" width="550" height="550" class="imagem1">
            </div>
        </div>
    </section>

    <section>
        <div class="circle"></div>
        <div class="content">
            <div class="imgBox">
                <img src="https://imgur.com/tgI1dB4.jpg.png" width="550" height="550" class="imagem">
            </div>
            <div class="textBox mr-5">
                <h2>A nossa <span>visão</span></h2>
                <br />
                <p>Consolidar-se dentro do mercado e tornar-se referência para outras redes sociais do mesmo segmento,
                    promovendo um reconhecimento nacional e ampliação do número de usuários dentro da plataforma. </p>
            </div>

        </div>
    </section>

    <section>
        <div class="content">
            <div class="textBox ml-5">
                <h2>Os nossos <span>valores</span></h2>
                <br />
                <p>Reutilização, bem-estar, empatia, ecologia, boa ação e repasse de bens materiais.</p>
                <a class="btn mt-4" routerLink="/cadastrar">Cadastre-se</a>
            </div>
            <div class="imgBox">
                <img src="https://imgur.com/pckA2Er.jpg.png" width="550" height="550" class="imagem1">
            </div>
        </div>
    </section>


    <div class="container-fluid">
        <app-equipe></app-equipe>
    </div>

    <app-rodape></app-rodape>
    

</body>

</html>